<template>
    <div class="dialog-bar" :style="{ backgroundColor: color, color: textColor }">
        <v-btn icon :color="textColor" title="Close" @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="dialog-bar__center">
            <div v-if="subtitle" class="dialog-bar__subtitle">{{ subtitle }}</div>
            <div class="dialog-bar__title">
                {{ title }}
                <span v-if="count !== null" class="dialog-bar__count">{{ count }}</span>
            </div>
            <slot />
        </div>
        <div class="dialog-bar__actions">
            <slot name="actions" />
        </div>
    </div>
</template>

<script>
    // Sticky header for the full-screen stats dialogs, painted in the team colour
    export default {
        name: 'StatsDialogBar',
        props: {
            title: {
                type: String,
                required: true
            },
            subtitle: {
                type: String,
                default: null
            },
            count: {
                type: Number,
                default: null
            },
            color: {
                type: String,
                default: '#000000'
            },
            textColor: {
                type: String,
                default: '#ffffff'
            }
        }
    }
</script>

<style scoped>
    .dialog-bar {
        position: sticky;
        top: 0;
        z-index: 3;
        display: flex;
        align-items: center;
        gap: 4px;
        min-height: 64px;
        padding: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
    .dialog-bar__center {
        flex: 1;
        min-width: 0;
        text-align: center;
    }
    .dialog-bar__subtitle {
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        opacity: 0.85;
    }
    .dialog-bar__title {
        font-size: 18px;
        font-weight: 800;
        line-height: 1.2;
        overflow-wrap: anywhere;
    }
    .dialog-bar__count {
        display: inline-block;
        min-width: 24px;
        margin-left: 4px;
        padding: 0 7px;
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.25);
        font-size: 13px;
        line-height: 22px;
        vertical-align: middle;
    }
    .dialog-bar__actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        min-width: 36px;
    }
</style>
